// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_2NcJy","cell":"_37IfQ","imageWrapper":"_1ZvYZ","image":"qgK9z"};